module.exports = __webpack_public_path__ + "img/logo.9dacff94.svg";